export default "__VITE_ASSET__BHO_4okq__"